module.exports = ".tech-domains-list-title {\n  text-align: center;\n  color: #091e42;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: bold;\n  font-family: Montserrat-Regular;\n  margin-top: 20px;\n  margin-bottom: 0px;\n}\n.text-placeholder-default {\n  color: #062b3e !important;\n}\n.list-item-wrapper-white.active {\n  border: 2px solid #fb625c;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/tech-domains-list/tech-domains-list.component.css
// module id = ./src/app/feature/main/roles-shared/components/tech-domains-list/tech-domains-list.component.css
// module chunks = main